var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"has-text-grey-light is-size-7",attrs:{"slot":"trigger"},slot:"trigger"},[_c('b-icon',{attrs:{"icon":"magnify","size":"is-small"}}),_vm._v(" Advanced Search Options ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }